export default "__VITE_ASSET__a73260b2__"